import clsx from "clsx"
import { npPagePxClassName, npSectionMtClassName } from "src/components/np-design/components/constants"
import { useProductContext } from "./context"

export const ProductSeoText = () => {
  const { seoText } = useProductContext()

  if (!seoText?.trim().length) {
    return null
  }

  return (
    <article
      className={clsx(npPagePxClassName, npSectionMtClassName, "RichText mb-4")}
      dangerouslySetInnerHTML={{ __html: seoText }}
    />
  )
}
